export { ImageGrid, type ImageGridProps } from './ImageGrid';
